import o, { forwardRef as D, isValidElement as L } from "react";
import { XCircle as B } from "@olxbr/ds-icons";
import { Text as f } from "../Text/Text.js";
import { cls as c } from "../../helpers/cls.js";
import { withDisplay as I } from "../../helpers/display.js";
import { spacingReplace as i } from "../../helpers/spacingReplace.js";
var P = Object.defineProperty,
  n = Object.getOwnPropertySymbols,
  x = Object.prototype.hasOwnProperty,
  b = Object.prototype.propertyIsEnumerable,
  u = (e, r, a) => r in e ? P(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: a
  }) : e[r] = a,
  E = (e, r) => {
    for (var a in r || (r = {})) x.call(r, a) && u(e, a, r[a]);
    if (n) for (var a of n(r)) b.call(r, a) && u(e, a, r[a]);
    return e;
  },
  V = (e, r) => {
    var a = {};
    for (var l in e) x.call(e, l) && r.indexOf(l) < 0 && (a[l] = e[l]);
    if (e != null && n) for (var l of n(e)) r.indexOf(l) < 0 && b.call(e, l) && (a[l] = e[l]);
    return a;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const j = 'Se o radio n\xE3o possuir um label textual descritivo \xE9 necess\xE1rio informar o atributo "aria-label"',
  C = 'A prop label precisa ser do tipo "ReactNode"',
  T = _ref => {
    let {
      label: e,
      outline: r,
      checked: a
    } = _ref;
    if (!e) return null;
    if (typeof e == "string") return o.createElement(f.BodyMedium, {
      className: c("olx-radio__label-text", r && a && "olx-radio__label-text--checked"),
      marginLeft: "--spacing-1"
    }, e);
    if (L(e)) return o.createElement("span", {
      className: "olx-radio__label-wrapper"
    }, e);
    throw new Error(C);
  },
  g = D((e, r) => {
    const a = e,
      {
        error: l,
        errorMessage: m,
        label: s,
        checked: t,
        disabled: d,
        display: w,
        "aria-label": p,
        margin: N,
        marginBottom: h,
        marginLeft: y,
        marginRight: v,
        marginTop: O,
        outline: R,
        className: S,
        icon: _
      } = a,
      k = V(a, ["error", "errorMessage", "label", "checked", "disabled", "display", "aria-label", "margin", "marginBottom", "marginLeft", "marginRight", "marginTop", "outline", "className", "icon"]);
    if (!s && !p) throw new Error(j);
    return o.createElement("label", {
      "data-ds-component": "DS-Radio",
      "aria-disabled": d,
      className: c("olx-radio", t && "olx-radio--checked", R && "olx-radio--outline", t && !l && "olx-radio--checked", t && l && "olx-radio--checked-error", l && "olx-radio--error", S, i("olx-m", N), i("olx-ml", y), i("olx-mb", h), i("olx-mt", O), i("olx-mr", v), I(w))
    }, o.createElement("span", {
      className: "olx-radio__content-wrapper"
    }, o.createElement("span", {
      className: "olx-radio__content"
    }, o.createElement("span", {
      className: "olx-radio__input-wrapper"
    }, o.createElement("input", E({
      "aria-label": p,
      ref: r,
      checked: t,
      disabled: d,
      type: "radio",
      className: "olx-radio__native"
    }, k)), o.createElement("span", {
      className: "olx-radio__stylized"
    })), _ && o.createElement("span", {
      "aria-hidden": !0,
      className: c("olx-radio__custom-icon", t && "olx-radio__custom-icon--checked")
    }, _), o.createElement(T, E({}, e))), s && m && o.createElement("span", {
      className: "olx-radio__error-message"
    }, o.createElement(B, {
      size: "16px"
    }), o.createElement(f.Caption, {
      role: "alert",
      marginTop: "--spacing-0-25",
      tag: "p"
    }, m))));
  });
g.displayName = "Radio";
export { g as Radio };